(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sc-ean"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const variante = event.detail && event.detail.resource;
    if (!variante) return;
    const produit = String((event.detail.data && event.detail.data.productId) || '');
    document.querySelectorAll('.sc-ean').forEach((ligne) => {
      if (produit && ligne.dataset.productId !== produit) return;
      const ean = variante.barcode || '';
      ligne.querySelector('.sc-ean__valeur').textContent = ean;
      ligne.hidden = !ean;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
